import Cookies from "js-cookie";

export const createQueries = (queries) =>
  Object.entries(queries)
    .map((e) => e.join("="))
    .join("&");

export const getCurrentUserToken = () => {
  return {
    token: window.appToken || Cookies.get("appToken"),
    userId: window.userID || Cookies.get("userID"),
  };
};

export const request = (path, options) => {
  return fetch(path, options).then((res) => {
    if (res.status === 204 || res.status === 304) {
      return true;
    }

    return res.json().catch((x) => null);
  });
};

export const requestGapi = (
  path,
  { query, returnResponse = false, ...options } = {},
) => {
  const { token } = getCurrentUserToken();
  // 将 query 的参数拼接到 path 后面
  if (query) {
    path += "?" + createQueries(query);
  }
  const requestOptions = {
    ...options,
    headers: {
      ...options.headers,
      ...(!(options.body instanceof FormData)
        ? { "Content-Type": "application/vnd.api+json" }
        : {}),
      ...(token ? { Authorization: `Token token=${token}` } : {}),
    },
  };

  const host = (() => {
    if (location.hostname.includes("game-cores")) {
      return "https://www.game-cores.com";
    }
    if (location.hostname.includes("gcores")) {
      return "https://www.gcores.com";
    }
    if (
      location.hostname.includes("localhost") ||
      location.hostname.includes("127.0.0.1")
    ) {
      return "";
    }
  })();

  const requestPath = `${host}/gapi/v1/${path}`;

  if (returnResponse) {
    return fetch(requestPath, requestOptions);
  }

  return request(requestPath, requestOptions);
};

let currentUser = undefined;
export const requestCurrentUser = () => {
  if (currentUser !== undefined) {
    return Promise.resolve(currentUser);
  } else {
    const { userId, token } = getCurrentUserToken();
    if (!(userId && token)) {
      return Promise.resolve(null);
    }
    return requestGapi(`users/${userId}`).then((res) => {
      return buildRels(res);
    });
  }
};

export const requestGserver = (path, options) => {
  return request(`https://www.gcores.com/${path}`, options);
};

function processItems(inputData, parse) {
  if (Array.isArray(inputData)) {
    const parsedItems = inputData.map((item) => parse(item));
    return parsedItems;
  }

  return parse(inputData);
}

export const buildRels = (res) => {
  if (!res || !res.data) {
    return null;
  }

  return processItems(res.data, (item) => {
    return {
      ...item,
      rels: buildItemRels(item, res.included),
    };
  });
};

const buildItemRels = (item, included) => {
  const rels = {};
  if (!item || !item.relationships) {
    return rels;
  }

  for (const relName of Object.keys(item.relationships)) {
    const { data: relUniques } = item.relationships[relName] || {};
    if (!relUniques) {
      continue;
    }

    rels[relName] = processItems(relUniques, (relUnique) => {
      const found = included.find(
        (x) => relUnique.type === x.type && relUnique.id === x.id,
      );
      return {
        ...found,
        rels: buildItemRels(found, included),
      };
    });
  }
  return rels;
};
